import { CredentialEntity, ServiceAuthType } from '@uploadcam/common';
import { CheckLoginPostConditionsInteractor } from '../../auth/domain/interactors/check-login-post-conditions.interactor';
import { GetUserInteractor } from '../../auth/domain/interactors/get-user.interactor';
import { GetTeamByIdInteractor } from '../../team/domain/interactors/get-team-by-id.interactor';
import { FailedLoginPostConditionError } from '../../auth/domain/errors/failed-login-post-condition.error';

export class CheckLoginPostConditionsMicrosoftInteractor
  implements CheckLoginPostConditionsInteractor
{
  constructor(
    private readonly getTeamById: GetTeamByIdInteractor,
    private readonly getUser: GetUserInteractor,
  ) {}

  public async execute(credential: Readonly<CredentialEntity>): Promise<void> {
    const user = await this.getUser.execute();

    if (user.teamId) {
      const team = await this.getTeamById.execute(user.teamId);
      const hasSiteId = !!team.metadata?.microsoftSiteId;

      if (credential.authType === ServiceAuthType.MicrosoftTeamFull && hasSiteId) {
        throw new FailedLoginPostConditionError('login.error.microsoft.requiresSites');
      } else if (credential.authType === ServiceAuthType.MicrosoftTeamSites && !hasSiteId) {
        throw new FailedLoginPostConditionError('login.error.microsoft.requiresFull');
      }
    }
  }
}
